import type { SaveStateInfo } from "../server/types";

type Props = {
  totalFrames: number;
  deaths: number;
  rewinds: number;
  attempt: number;
  bestFrames: number | null;
  saveStates: SaveStateInfo[];
};

function padNumber(n: number, len: number): string {
  return String(n).padStart(len, "0");
}

export function GameStatePanel({
  totalFrames,
  deaths,
  rewinds,
  attempt,
  bestFrames,
  saveStates,
}: Props) {
  return (
    <div className="flex flex-col gap-3">
      {/* Stats */}
      <div className="nes-panel">
        <div className="nes-panel-header">GAME STATE</div>
        <div className="p-3 font-pixel text-xs space-y-1.5">
          <div className="flex justify-between">
            <span className="text-nes-gray">FRAME</span>
            <span className="text-nes-white">{padNumber(totalFrames, 6)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-nes-gray">DEATHS</span>
            <span className="text-nes-red">{padNumber(deaths, 3)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-nes-gray">REWIND</span>
            <span className="text-nes-gold">{padNumber(rewinds, 3)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-nes-gray">ATTEMPT</span>
            <span className="text-nes-white">{attempt}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-nes-gray">BEST</span>
            <span className="text-nes-green">
              {bestFrames !== null ? padNumber(bestFrames, 6) : "---"}
            </span>
          </div>
        </div>
      </div>

      {/* Save States */}
      <div className="nes-panel">
        <div className="nes-panel-header">SAVE STATES</div>
        <div className="p-3 font-pixel text-xs space-y-1">
          {saveStates.length === 0 ? (
            <span className="text-nes-gray">No saves yet</span>
          ) : (
            saveStates.map((ss) => (
              <div key={ss.slotName} className="flex justify-between">
                <span className="text-nes-green truncate mr-2">● {ss.slotName}</span>
                <span className="text-nes-gray shrink-0">f:{ss.frameNumber}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
